import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ur',
    fullName: 'Urdu',
    nativeName: 'اردو',
    direction: 'rtl'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "کچھ حیرت انگیز آرہا ہے۔",
    landing_subtitle: "ArgVoid ایک ایپ اور گیم ڈویلپمنٹ اسٹوڈیو ہے۔ دیکھتے رہیں، نئی چیزیں جلد آرہی ہیں!",
    select_language: "زبان منتخب کریں۔",
    search_placeholder: "زبانیں تلاش کریں...",
    terms_title: "سروس کی شرائط",
    policy_title: "رازداری کی پالیسی",
    cookies_title: "کوکی پالیسی",
    terms_content: `
        <strong>1۔ شرائط</strong><br> کی قبولیت
        ArgVoid تک رسائی کرکے، سروس کی یہ شرائط قبول کی جاتی ہیں۔ اگر ان شرائط سے اتفاق نہیں کیا جاتا ہے، تو سروس استعمال نہیں کی جانی چاہیے۔<br><br>

        <strong>2۔ پلیٹ فارم کا استعمال </strong><br>
        ArgVoid اور اس کی درخواستیں معلوماتی اور تخلیقی مقاصد کے لیے "جیسا ہے" فراہم کی جاتی ہیں۔ سروس کو صرف قانونی مقاصد کے لیے استعمال کیا جانا چاہیے۔<br><br>

        <strong>3۔ ممنوعہ Conduct</strong><br>
        سائٹ کی کمزوریوں کا فائدہ اٹھانا، سپیمنگ کرنا، یا انفراسٹرکچر تک غیر مجاز رسائی کی کوشش کرنا سختی سے ممنوع ہے۔<br><br>

        <strong>4۔ ڈس کلیمر</strong><br>
        پلیٹ فارم اور خدمات میں کسی بھی وقت بغیر اطلاع کے ترمیم کی جا سکتی ہے۔ سروس کے اپ ٹائم یا دستیابی کے حوالے سے کوئی وارنٹی فراہم نہیں کی جاتی ہے۔
    `,
    policy_content: `
        <strong>1۔ معلومات کا مجموعہ</strong><br>
        پلیٹ فارم کو اس وقت صارف کی توثیق یا اکاؤنٹ بنانے کی ضرورت نہیں ہے۔ کوئی ذاتی شناخت کرنے والی معلومات (جیسے نام یا ای میل پتے) زائرین سے فعال طور پر جمع نہیں کی جاتی ہیں۔<br><br>

        <strong>2۔ استعمال کا ڈیٹا</strong><br>
        سائٹ ٹریفک کو سمجھنے اور ایپلی کیشنز کو بہتر بنانے کے لیے بنیادی، گمنام تجزیات جمع کیے جا سکتے ہیں۔ یہ ڈیٹا انفرادی صارف کی شناخت سے منسلک نہیں ہے۔<br><br>

        <strong>3۔ فریق ثالث کی خدمات</strong><br>
        تیسرے فریق فراہم کنندگان کو ہوسٹنگ اور تجزیاتی خدمات کے لیے استعمال کیا جا سکتا ہے۔ ان متعلقہ فراہم کنندگان کے رازداری کے طریقے ان کے انفراسٹرکچر پر پروسیس کیے گئے گمنام ڈیٹا کو کنٹرول کرتے ہیں۔<br><br>

        <strong>4۔ ڈیٹا سیکیورٹی</strong><br>
        پلیٹ فارم کی حفاظت کے لیے مناسب حفاظتی اقدامات نافذ کیے گئے ہیں۔ تاہم، انٹرنیٹ پر ترسیل کا کوئی طریقہ مکمل طور پر محفوظ نہیں ہے۔<br><br>
    `,
    cookies_content: `
        <strong>1۔ کوکیز اور لوکل سٹوریج کیا ہیں؟</strong><br>
        کوکیز اور براؤزر لوکل سٹوریج چھوٹی ڈیٹا فائلیں ہیں جو آلے پر محفوظ کی جاتی ہیں تاکہ وزٹ کے دوران کنفیگریشن کی ترجیحات کو یاد رکھا جا سکے۔<br><br>

        <strong>2۔ استعمال کا مقصد</strong><br>
        براؤزر لوکل سٹوریج کو ترتیب کی ترتیبات کو محفوظ کرنے کے لیے سختی سے استعمال کیا جاتا ہے، جیسے: <br>
        - زبان کی ترجیحات<br>
        - یوزر انٹرفیس کی ترتیب (مثال کے طور پر، لے آؤٹ یا تھیم کی ترتیبات) <br>
        - عارضی ایپلیکیشن cache<br><br>

        <strong>3۔ کوئی Tracking</strong><br> نہیں۔
        کوکیز اور مقامی سٹوریج کا استعمال اشتہارات یا تیسرے فریق سے باخبر رہنے کے مقاصد کے لیے نہیں کیا جاتا ہے۔ تمام ذخیرہ شدہ ڈیٹا پلیٹ فارم کی بنیادی فعالیت کے لیے سختی سے ہے۔<br><br>

        <strong>4۔ کنٹرول ایکس 19 ایکس ایکس 20 ایکس
        براؤزر کی ترتیبات کے ذریعے براؤزر ڈیٹا کو کسی بھی وقت صاف کیا جا سکتا ہے، جو کسی بھی مقامی ترتیب کو دوبارہ ترتیب دے گا۔
    `,
    cookie_consent_text: "ہم ویب سائٹ کے کاموں کو درست طریقے سے یقینی بنانے کے لیے بنیادی کوکیز کا استعمال کرتے ہیں، جیسے کہ آپ کے سیشن کو فعال رکھنا، آپ کی زبان کی ترجیح کو محفوظ کرنا، اور دیگر حسب ضرورت تشکیلات۔",
    read_policy: "کوکی پالیسی پڑھیں",
    support_title: "سپورٹ سے رابطہ کریں۔",
    support_subject_label: "موضوع",
    support_message_label: "پیغام",
    support_submit_button: "پیغام بھیجیں۔",
    support_hint: "نوٹ: اس سے پیغام بھیجنے کے لیے آپ کی ڈیفالٹ ای میل ایپلیکیشن کھل جائے گی۔",
    support_success_msg: "آپ کی ای میل ایپ کھولی جا رہی ہے...",
    support_error_msg: "پیغام بھیجنے میں ناکام۔ براہ کرم بعد میں دوبارہ کوشش کریں۔",
    explorer_title: "ایکسپلورر",
    history_title: "تاریخ",
    animation_title: "حرکت پذیری",
    config_title: "کنفیگریشن",
    tool_mouse: "منتخب کریں (Ctrl+M)",
    tool_brush: "برش (Ctrl+B)",
    tool_brush_mode: "ٹوگل موڈ (ٹھوس/صاف)",
    tool_eraser: "صاف کرنے والا (Ctrl+E)",
    tool_brush_size: "برش کا سائز ایڈجسٹ کریں۔",
    tool_bucket: "بھریں (Ctrl+F)",
    tool_eyedropper: "آئی ڈراپر",
    tool_grid: "گرڈ (Ctrl+Shift+B)",
    tool_rotate: "گھمائیں (Ctrl+Shift+R)",
    tool_flip_h: "پلٹائیں H (Ctrl+Shift+H)",
    tool_flip_v: "پلٹائیں V (Ctrl+Shift+V)",
    tool_transpose: "ٹرانسپوز (Ctrl+Shift+T)",
    label_width: "چوڑائی",
    label_height: "اونچائی",
    label_frames: "فریموں کی تعداد",
    label_animation: "حرکت پذیری کا انداز",
    label_background_color: "پس منظر کا رنگ",
    label_interval: "وقفہ",
    tool_anim_config: "حرکت پذیری کی ترتیب",
    label_new_width: "نئی چوڑائی",
    label_new_height: "نئی اونچائی",
    label_apply: "لگائیں",
    label_colors: "رنگ",
    label_size: "سائز",
    label_tolerance: "رواداری",
    val_horizontal: "افقی",
    val_vertical: "عمودی",
    val_sequence: "ترتیب",
    val_bounce: "اچھالنا",
    val_random: "بے ترتیب",
    val_solid: "ٹھوس",
    val_clear: "صاف",
    action_add_sheet: "نئی شیٹ",
    action_import: "درآمد کریں۔",
    action_export: "برآمد کریں۔",
    action_sort_projects: "چھانٹنا",
    sort_date_old: "سب سے پرانا پہلا",
    sort_date_new: "تازہ ترین پہلے",
    sort_name_az: "نام (A-Z)",
    sort_name_za: "نام (Z-A)",
    action_new_sprite: "نیا سپرائٹ",
    action_new_project: "نیا پروجیکٹ",
    modal_save_all_title: "تمام تبدیلیاں محفوظ کریں۔",
    modal_save_all_desc: "محفوظ کرنے کے لیے اثاثوں کو منتخب کریں:",
    modal_save_selected: "منتخب کردہ کو محفوظ کریں۔",
    action_saved: "محفوظ کیا گیا۔",
    modal_create_sprite_title: "نیا سپرائٹ بنائیں",
    modal_create_project_title: "نیا پروجیکٹ بنائیں",
    modal_add_sheet_title: "نئی شیٹ شامل کریں۔",
    modal_rename_sheet_title: "شیٹ کا نام تبدیل کریں۔",
    modal_rename_sprite_title: "سپرائٹ کا نام تبدیل کریں۔",
    modal_delete_sprite_title: "سپرائٹ کو حذف کریں۔",
    modal_delete_project_title: "پروجیکٹ کو حذف کریں۔",
    modal_delete_sheet_title: "شیٹ کو حذف کریں۔",
    placeholder_sprite_name: "نام",
    placeholder_project_name: "نام",
    placeholder_sheet_name: "نام",
    placeholder_new_name: "نیا نام",
    action_create: "بنائیں",
    action_add: "شامل کریں۔",
    action_rename: "نام تبدیل کریں۔",
    action_duplicate: "نقل",
    action_delete: "حذف کریں۔",
    action_cancel: "منسوخ کریں۔",
    confirm_delete_sprite: "کیا آپ واقعی اس سپرائٹ کو حذف کرنا چاہتے ہیں؟",
    confirm_delete_project: "کیا آپ واقعی اس پروجیکٹ کو حذف کرنا چاہتے ہیں؟ تمام اسپرائٹس کو ہٹا دیا جائے گا۔",
    confirm_delete_sheet: "کیا آپ واقعی اس شیٹ کو حذف کرنا چاہتے ہیں؟",
    err_select_sprite: "براہ کرم پہلے ایک سپرائٹ منتخب کریں۔",
    err_select_project: "براہ کرم پہلے ایک پروجیکٹ منتخب کریں۔",
    err_name_empty: "نام خالی نہیں ہو سکتا۔",
    err_sprite_exists: "اس نام کے ساتھ ایک سپرائٹ پہلے سے موجود ہے۔",
    err_project_exists: "اس نام کا ایک پروجیکٹ پہلے سے موجود ہے۔",
    err_no_content: "محفوظ کرنے کے لیے کوئی مواد نہیں ہے۔",
    err_no_changes: "محفوظ کرنے کے لیے کوئی تبدیلی نہیں۔",
    err_delete_last_sheet: "آخری شیٹ کو حذف نہیں کیا جا سکتا۔",
    err_extract_frames: "کوئی فریم نہیں نکالا جا سکا۔",
    err_indexeddb: "مقامی طور پر محفوظ کرنے میں ناکام۔ ہو سکتا ہے آپ کا براؤزر IndexedDB کو سپورٹ نہ کرے۔",
    msg_upload_success: "اپ لوڈ کامیاب: {0}",
    msg_upload_failed: "اپ لوڈ ناکام: {0}",
    msg_save_success: "محفوظ کریں کامیاب۔",
    msg_saving: "محفوظ کر رہا ہے...",
    msg_multi_save_result: "محفوظ کردہ {0} اثاثے {1} ناکامیاں۔",
    menu_title: "مینو",
    menu_save: "محفوظ کریں۔",
    menu_save_all: "سب کو محفوظ کریں۔",
    menu_support: "سپورٹ سے رابطہ کریں۔",
    label_local_storage: "مقامی اسٹوریج",
    label_sign_in: "سائن ان کریں۔",
    modal_export_title: "سپرائٹ برآمد کریں۔",
    label_filename: "فائل کا نام",
    label_format: "فارمیٹ",
    action_export_confirm: "برآمد کریں۔",
};

export default translations;
